<template>
    <div class="board_card mb template2">
        <div class="category">
            <div class="amount">{{ params.data }}</div>
            <div class="name">{{ params.title }}</div>
        </div>
        <div
            v-show="hasRecentSold"
            class="tendency"
            :class="[
                { up: params.status === 1, down: params.status === -1 },
                params.class ? params.class : ''
            ]"
        >
            <!--  more than the  0  or   less than  0 -->
            <div
                class="data_wrap"
                v-if="
                    (params.status === 1 || params.status === -1) &&
                        !params.dataComing
                "
            >
                <span
                    class="iconfont"
                    :class="{
                        'icon-trend-up': params.status > 0,
                        'icon-trend-down': params.status < 0
                    }"
                ></span>
                <span class="num">{{ params.changeNum }}</span>
            </div>
            <!--  equal  0 -->
            <div
                class="no_data"
                v-else-if="params.status === 0 && !params.dataComing"
            >
                <span>{{ params.changeNum }}</span>
            </div>
            <!-- 30-60 No listings sold  -->
            <div class="no_data" v-else>
                <span>{{ params.dataComing ? '' : '-' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'board-mb',
    props: {
        params: Object,
        hasRecentSold: Boolean
    }
};
</script>

<style lang="scss">
@import './board.scss';
.board_card.mb.template2 {
    margin-right: 30px;
    width: 80vw !important;
    height: 150px;
    box-sizing: border-box;
    padding: 40px 30px;
    border: 1px solid var(--color-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    &:last-child {
        margin-right: 20px;
    }
    .category{
        flex-direction: column;
        align-items: center;
    }
}
</style>
